export const NIAT_PORTAL_TERMS_AND_CONDITIONS_URL =
  'https://www.niatindia.com/terms-and-conditions-2025';
export const NIAT_PORTAL_PRIVACY_POLICY_URL = 'https://ccbp.in/privacy-policy';

export const defaultTermsAndConditionsLabel = `
I hereby agree to the&nbsp;<a href='${NIAT_PORTAL_TERMS_AND_CONDITIONS_URL}' target='_blank' class='paymentTerms' style='cursor: pointer;' referrerpolicy='no-referrer-when-downgrade'> Terms & Conditions</a>&nbsp;and&nbsp;<a href='${NIAT_PORTAL_PRIVACY_POLICY_URL}' target='_blank' class='paymentTerms' style='cursor: pointer;' referrerpolicy='no-referrer-when-downgrade'> Privacy Policy</a>&nbsp;of NxtWave.`;

export const defaultRefundPolicyLabel =
  'By proceeding, I acknowledge and accept that all payments made are final and non-refundable under any circumstances.';
